import { render, staticRenderFns } from "./CurrentChange.vue?vue&type=template&id=c7cc7a80"
import script from "./CurrentChange.vue?vue&type=script&lang=js"
export * from "./CurrentChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports